import React, { useState, useEffect, useRef, useContext} from 'react'
import * as Constants from '../../constants';
import BackLoader from '../../components/backloader'
import JisButton from '../controls/jisButton';
import { ShareContext } from '../../context/ShareContext'
export default function JisInternalPay({isPay, name, email,phone, amount, note, 
    onCancel, children }) {
  const {  activePage, token, profile,frequentData,setIsExpired} = useContext(ShareContext);
    const [gateway, setGateway] = useState(null);
    const [loading, setLoading] = useState(false);
    const [payinfo, setPayInfo] = useState(null);
    //const [billRef, setBillRef] =useState(null);
    const billRef= useRef(null);
     const formRef = useRef();
     const [pi, setPi] =useState([]);
     //const billRef = useRef()

    useEffect(() => {     
            
            onLoad();
    }, [])

     useEffect(() => {     
     
        const _pi=note.split('-');
        console.log(_pi);
        setPi(_pi);
    }, [note])  

                
    const onLoad= async()=>{
    //for account registration
        const url=`${Constants.apiUrl}/payment/current-gateway`;
    console.log(`the calling url ${url}`);
    try {
        setLoading(true);
        const resp = await fetch(url, { 
            method: 'GET',
            headers: {
            'Content-Type': 'application/json',
            },
        });
        
        const data = await resp.json();
        
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
            setGateway(data.current);
            
        }else {    
            alert(data.status);
        }
        } catch (error) {
        setLoading(false);
        console.error(error);
        
        }

    }

    const ProcessPay=async()=>{
               
              
    setLoading(true);
    
    try {
    
    var payinfo={id:0,payType:pi[0],note,amount,gatewayId:gateway.id, 
        isPaid:false, divisionId:pi[5], externalAmount:(amount-250), internalAmount:250};
    const resp = await fetch(`${Constants.apiUrl}/payment/initiate-internal-pay`, {
        method: 'POST',
        body:JSON.stringify(payinfo) ,
        headers: {
        'Content-Type': 'application/json, text/plain',
        'Authorization': `Bearer ${token}`,
        },
    });
    
    const data = await resp.json();
    setLoading(false);
    console.log(data);
    if (data.code === 0) {
        //setGazettes(data.gazettes);
        console.log('bill... '+data.id)
        var bill=`JISI${data.id}`;
        billRef.current=bill;
       localStorage.setItem("internalid",bill); 
        
         if(gateway?.name=='Pay4it'){
            window.location=`https://usepay4it.com/payment/collection/mda?mda=${Constants.pay4it_key}&callbackUrl=${Constants.payment_callback_internal}&internalBillReference=${bill}`;
        }else if(gateway?.name=='Paystack'){
            window.location=`${Constants.baseurl}/paystack.html?name=${name}&email=${email}&phone=${phone}&returnurl=${`${Constants.payment_callback_internal}/`}&amount=${amount}&docref=${bill}`
            
        }
     
        //window.location=`https://usepay4it.com/payment/collection?mda=${Constants.pay4it_key}&tx_reference=${data.webGuid}&callbackUrl=${Constants.pay4it_callback}`;
    }else if(data.code==-10){   
        setIsExpired(true);
    }
    } catch (error) {
    setLoading(false);
    console.error(error);
    // setErr(Constants.serverErr);
    // onMove();
    }

    }

    const onPay4it=()=>{
        //process pay for it link here
            if (formRef.current) {
                formRef.current.requestSubmit(); // preferred over formRef.current.submit()
                }
    }
    //swtich happen here
  return (
    isPay && <div className={ "success open" }>
                <div className="success-box">
                    <h2>{Constants.formatCurrency(amount) }</h2>
                    <span style={{fontSize:12, fontWeight:'bold'}}>{gateway?.name}</span>
                    <p>Payment for Affidavit  </p>
                    {children}
                 {/* {gateway?.name=='Paystack' && <form ref={formRef} className='form-inp' action='/paystack.html'>
                        <input type='hidden' name="name" value={name}  />
                        <input type='hidden' name="email" value={email}   />
                        <input type='hidden' name="phone" value={phone}   />
                        <input type='hidden' name="returnurl" value={`${Constants.payment_callback_internal}/`}   />
                        <input type='hidden' name="amount" value={amount} />
                        <input type='hidden' name="docref" value={billRef.current} />
                      
                    </form>} */}
               
                    <div style={{display:'flex', justifyContent:'center'}}>
                        <JisButton icon="check_circle" onClick={ProcessPay}>Pay Now</JisButton> 
                    <JisButton icon="close" variant={'outline'} onClick={onCancel} type='button'>Cancel</JisButton> </div>         
                </div>
                <BackLoader open={loading} />
            </div>

  );
}
